<template lang="pug">
    checkbox.justify-center(@value="onChange" :checked="item[field] ")
        .ml-2.text-xs отправлен
</template>

<script>
import Checkbox from '@/components/common/checkbox';
//Store
/* eslint-disable no-unused-vars */
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';

export default {
    name: "GiftSent",
    components: {
        'checkbox': Checkbox,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        context: {
            type: Object,
            default: () => ({
                name_space: 'users',
                action: 'EditUser',
            }),
        },
        field: {
            type: String,
            required: true,
        },
    },
    methods: {
        async onChange(value) {
            await this.$store.dispatch(`${this.context.name_space}/${this.context.action}`, { id: this.item._id, value: {[this.field]: value} })
        },
    }
}
</script>